import {FC, lazy, Suspense} from 'react'
import {Navigate, Route, Routes} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'

const PrivateRoutes = () => {
  const ScheduleLectures = lazy(() => import('../pages/scheduleLectures'))
  const CustomerManagement = lazy(() => import('../pages/customerManagement'))
  const StaffManagement = lazy(() => import('../pages/staffManagement'))
  const CalendarAndReservation = lazy(() => import('../pages/calendarAndReservation'))
  const FacilityRoomAndGates = lazy(() => import('../pages/facilityRoomAndGates'))
  const GeneralSettings = lazy(() => import('../pages/generalSettings'))
  const FinancialManagement = lazy(() => import('../pages/financialManagement'))
  const Reports = lazy(() => import('../pages/reports'))
  const HelpCenter = lazy(() => import('../pages/helpCenter'))

  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />
        {/* Lazy Modules */}
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />

        <Route
          path='customer-management/*'
          element={
            <SuspensedView>
              <CustomerManagement />
            </SuspensedView>
          }
        />
        <Route
          path='staff-management/*'
          element={
            <SuspensedView>
              <StaffManagement />
            </SuspensedView>
          }
        />
        <Route
          path='calendar-and-reservation/*'
          element={
            <SuspensedView>
              <CalendarAndReservation />
            </SuspensedView>
          }
        />
        <Route
          path='facility-room-and-gates/*'
          element={
            <SuspensedView>
              <FacilityRoomAndGates />
            </SuspensedView>
          }
        />
        <Route
          path='general-settings/*'
          element={
            <SuspensedView>
              <GeneralSettings />
            </SuspensedView>
          }
        />
        <Route
          path='financial-management/*'
          element={
            <SuspensedView>
              <FinancialManagement />
            </SuspensedView>
          }
        />
        <Route
          path='schedule-lectures/*'
          element={
            <SuspensedView>
              <ScheduleLectures />
            </SuspensedView>
          }
        />
        <Route
          path='reports/*'
          element={
            <SuspensedView>
              <Reports />
            </SuspensedView>
          }
        />
        <Route
          path='help-center/*'
          element={
            <SuspensedView>
              <HelpCenter />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
